<script>
/*import { onMount } from 'svelte';
import * as user from '../user.js';
import * as utils from '../utils';
import { push, replace } from 'svelte-spa-router'
import { writable } from 'svelte/store';
import { FormValidator, InputValidator } from '../form.js';
*/

import { onMount } from 'svelte';
import { link, replace } from 'svelte-spa-router'

import firebase from '../firebase';
import * as utils from '../utils';
import * as user from '../user';

import Button from './button.svelte';
import AlternateHeader from './altheader.svelte';

onMount(() => { window.scrollTo(0,0); });

let password = '';
let email = '';

let accountExists = false;

let emailError = ''; //Sorry, your email address is invalid Please enter a valid email using this format: name@example.com';
let passwordError = '';
let signinError = '';

let signingIn = false;
let creating = false;

$:continueButtonState = creating ? 'loading' : '';
$:signinButtonState = signingIn ? 'loading' : '';

function Create()
{
    if (creating)
        return;

    creating = true;
    accountExists = false;
    emailError = passwordError = '';

    user.CreateAuthUser(email, password).then((u) => //, firstName, lastName, phone, providerType).then((user) =>
    {
        // yay we can continue!!!
        utils.log('CreateUser success', u);

        // send the verification email
        user.SendEmailVerification();

        //
        replace('/signup/verify');

    })
    .catch((error) =>
    {
        utils.error('Error creating auth user', error);
        if (error === 'auth/weak-password')
        {
            passwordError = 'Please use a password that is at least six characters long';
        }
        else if (error === 'auth/email-already-in-use')
        {
            // gah....
            accountExists = true;

            // haha this is cheating
            emailError = ' ';
        }
        else if (error === "auth/invalid-email")
        {
            emailError = 'Sorry, your email address is invalid Please enter a valid email using this format: name@example.com';
        }
        else
        {
            Dang("Oops. Something went wrong (code 1)");
        }
    })
    .then(() =>
    {
        setTimeout(function() {
            creating = false;
        }, 200);

    });
}

</script>

<AlternateHeader/>

<!-- Section -->
<div class="container main medium" style="margin-top: 0;">
<section class="line-after">
  <header class="major center">
      <div class="image"><img src="images/whiteLogo.png" alt="" /></div>
  </header>
</section>
  <section>
    <header>
        <h5>Step 1 of 4</h5>
        <h4>Create an account</h4>
    </header>
    <form on:submit|preventDefault={Create} novalidate>
      <div class="row gtr-uniform gtr-50">
        <div class="col-12 col-12-xsmall">
            <input class:error={emailError} placeholder="Email (name@example.com)" type="email" bind:value={email} />
          {#if emailError}
            <div class="errorMsg">{emailError}</div>
          {/if}
        </div>
        <div class="col-12 col-12-xsmall">
            <input class:error={passwordError} placeholder="Password (at least six characters)" type="password" bind:value={password} />
          {#if passwordError}
            <div class="errorMsg">{passwordError}</div>
          {/if}
        </div>
        <div class="col-12 col-12-xsmall">
          <ul class="actions special">
              <li>
                  <Button state={continueButtonState} class="button fit" text="CONTINUE"/>
              </li>
          </ul>
        </div>
        {#if accountExists}
            <div class="errorMsg">An account with this email already exists.</div>
            <div style="text-align:left; color: white;">Click here to <a href="/signin" use:link>sign in</a></div>
        {/if}
      </div>
    </form>
  </section>
</div>



<style>
@media screen and (max-width: 480px) {
  header.center {
    text-align: center;
}}

h5 {
  color: #c5c5c5 !important;
  font-weight:normal;
}

header.major { margin: 1em 0 0 0; }
.container > section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}

div.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 350px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 290px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}


</style>
